import { US, CA, EU } from "country-flag-icons/react/3x2";
import { cn } from "@/lib/utils";
import type { Region } from "@/lib/api/types";

const FLAG: Record<string, typeof US> = { EU, US, CA };

/** Real country/region flag (inline SVG, no emoji). 3:2 ratio, rounded. */
export function RegionFlag({ region, size = 22, className }: { region: Region | string; size?: number; className?: string }) {
  const Flag = FLAG[region] ?? EU;
  return (
    <span
      className={cn("inline-flex shrink-0 overflow-hidden rounded-[3px] ring-1 ring-black/10 dark:ring-white/15", className)}
      style={{ width: size }}
    >
      <Flag style={{ width: "100%", display: "block" }} />
    </span>
  );
}
